
export class Ambiente {

    public id: string;
    public id_cliente: string;
    public descricao: string;

    constructor(){

    }
}
